module.exports = __webpack_public_path__ + "img/turn_right.1b279786.svg";